<template>
  <scroll-area class="work-area workarea" ref="workArea">
    <div class="container">
      <div class="em-block">
        <div class="em-child">
          <div class="row">
            <div class="col">
              <h2>Experimental Features</h2>
              <hr>
            </div>
          </div>
          <feature id="object_model_diagrams">
            <view-experimental-object-model-diagrams></view-experimental-object-model-diagrams>
          </feature>
          <feature id="create_associated_views">
            <view-experimental-create-associated></view-experimental-create-associated>
          </feature>
        </div>
      </div>
    </div>
  </scroll-area>
</template>

<script lang="ts">
  import Vue from "vue";
  import ViewExperimentalCreateAssociated from "./view-experimental-create-associated.vue"
  import ViewExperimentalObjectModelDiagrams from "./view-experimental-object-model-diagrams.vue"
  import ViewSettingsDashboard from "./view-settings-dashboard.vue";
  import ViewSettingsLimits from "./view-settings-limits.vue";

  export default Vue.extend({
    components: {
      ViewExperimentalCreateAssociated,
      ViewExperimentalObjectModelDiagrams,
    },
    mixins: [
    ],
    data: function () {
      return {
      };
    },
    computed: {
    },
    methods: {
    },
  });
</script>